<template>
  <span @click="change" class="focus">
    <span v-if="isDone" class="report" :class="{right: isRight, wrong: !isRight}">
      <span v-if="showUserAnswer && !isRight">
        <span> &nbsp;&nbsp;{{answer}}&nbsp;&nbsp;</span>
        <span class="user-answer"> {{userAnswer}} </span>
      </span>
      <span v-else-if="!showUserAnswer && !isRight">
        <span> &nbsp;&nbsp;{{answer}}（未作答）&nbsp;&nbsp;</span>
      </span>
      <span v-else-if="!showUserAnswer && isRight">
        <span> &nbsp;&nbsp;{{answer}}&nbsp;&nbsp;</span>
      </span>
    </span>
    <span v-else class="chooseing" :class="{active: isActive, text: userAnswer}">
      <span class="blank"  v-if="userAnswer"> {{userAnswer}} </span>
      <span v-else>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{index}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
  </span>
</template>
<script>

export default {
  props: {
    index: Number,
    answer: {
      type: String,
      default: '',
    },
    userAnswer: {
      type: String,
      default: '',
    },
    isDone: {
      type: Boolean,
      default: false,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    showUserAnswer() {
      return !this.isRight && this.userAnswer;
    },
  },
  methods: {
    change() {
      this.$emit('change', this.index);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.focus {
  cursor: pointer;
  .chooseing {
    color: $primary;
    border: 1px solid $primary;
    border-radius: 2px;
    .blank {
      padding: 0 5px;
      text-decoration: underline;
    }
  }
  .text {
    border: none;
  }
  .active {
    background: $primary;
    color: #fff;
    .blank {
      padding: 0 10px;
      text-decoration: none;
    }
  }
  .report {
    color: #fff;
  }
  .right {
    background: $success;
    border-radius: 2px;
  }
  .wrong {
    background: $danger;
    border-radius: 2px;
    .user-answer {
      text-decoration: line-through;
      &:before{
        content: '(';
      }
      &:after{
        content: ')';
      }
    }
  }
}
</style>
